const schedule = {
  state: {
    currentUser: {
      image: 'johnDoe2.jpg',
      name: 'IP'
    },
    events: [
      {
        id: 1,
        start: '2019-05-28 08:00',
        end: '2019-05-28 16:00',
        class: 'unclaimed-shift',
        type: 'unclaimed',
        maxClaimers: 3
      },
      {
        id: 2,
        start: '2019-05-27 08:00',
        end: '2019-05-27 16:00',
        class: 'free-shift',
        type: 'free',
        maxClaimers: 2
      },
      {
        id: 3,
        start: '2019-05-31 08:00',
        end: '2019-05-31 16:00',
        class: 'remaining-shift',
        type: 'remaining',
        claimers: [
          {
            image: 'johnDoe.png',
            name: 'DZ'
          }
        ],
        maxClaimers: 2
      },
      {
        id: 4,
        start: '2019-05-31 16:00',
        end: '2019-05-31 24:00',
        class: 'full-shift',
        type: 'full',
        claimers: [
          {
            image: 'johnDoe.png',
            name: 'DZ'
          },
          {
            image: 'johnDoe2.jpg',
            name: 'PZ'
          }
        ],
        maxClaimers: 2
      },
      {
        id: 5,
        start: '2019-05-29',
        end: '2019-05-29',
        content: '',
        contentFull: 'asd',
        class: 'holiday',
        type: 'holiday',
        allDay: true
      },
      {
        id: 6,
        start: '2019-05-30',
        end: '2019-05-30',
        content: '',
        contentFull: 'asd',
        class: 'paid-leave',
        type: 'paidLeave',
        allDay: true
      }
    ]
  },
  getters: {
    getEvents: state => state.events
  },
  mutations: {
    UPDATE_EVENT: (state, payload) => {
      if (!payload.currentShift.claimers) {
        payload.currentShift.claimers = [];
      }
      payload.currentShift.claimers.push(payload.currentUser);
    },
    UPDATE_EVENT_TYPE: (state, payload) => {
      payload.currentShift.type = payload.type;
      payload.currentShift.class = payload.type + '-shift';
    }
  },
  actions: {
    claimShift: (context, id) => {
      const currentShift = context.state.events.find(x => x.id === id);
      // add current user to shift's claimers
      const loggedInUser = context.rootState.data.UserData;
      const first = loggedInUser.f_name.charAt(0);
      const second = loggedInUser.l_name.charAt(name.indexOf(' ') + 1);

      context.commit('UPDATE_EVENT', {
        currentShift,
        currentUser: {
          image: 'NT.jpg',
          name: first + second
        }
      });
      debugger;
      let type = '';
      if (
        currentShift.claimers.length >= 1 &&
        currentShift.claimers.length < currentShift.maxClaimers
      ) {
        type = 'remaining';
      } else if (currentShift.claimers.length === currentShift.maxClaimers) {
        type = 'full';
      }
      context.commit('UPDATE_EVENT_TYPE', {
        currentShift,
        type: type
      });

      const currentEvents = context.state.events;
      context.state.events = [];
      for (let event of currentEvents) {
        context.state.events.push(event);
      }
      // context.state.events = currentEvents;
      debugger;
    }
  }
};
export default schedule;



// WEBPACK FOOTER //
// ./src/store/modules/schedule.js